import React from "react";
import { Box, Container, Divider, Typography } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/it";

const formatDateEn = (value) =>
  value ? dayjs(value).locale("en").format("MMMM D, h:mm A") : "";

const formatDateIt = (value) =>
  value ? dayjs(value).locale("it").format("D MMMM YYYY, HH:mm") : "";

const Maintenance = ({ maintenanceInfo }) => {
  const { fromDate, toDate, messageIt, messageEn } = maintenanceInfo || {};

  return (
    <Box sx={{ minHeight: "100vh", display: "flex" }}>
      <Container
        component="main"
        maxWidth="md"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            gap: 3,
            textAlign: "center",
          }}
        >
          <img
            src={require("../img/kering_logo.png")}
            style={{ width: "20%", maxWidth: 200, minWidth: 120 }}
            alt="Kering"
          />
          <img
            src={require("../img/logo_APEEvo.png")}
            style={{ width: "20%", maxWidth: 200, minWidth: 120 }}
            alt="APE EVO"
          />

          <Box>            
            <Typography variant="body1" sx={{ mt: 2 }}>
              {messageIt}
            </Typography>
            {fromDate && toDate && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Prevista riapertura del servizio: {formatDateIt(toDate)}
              </Typography>
            )}
          </Box>

          <Divider sx={{ width: "60%" }} />

          <Box>
            <Typography variant="body1" sx={{ mt: 2 }}>
              {messageEn}
            </Typography>
            {fromDate && toDate && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Expected back online: {formatDateEn(toDate)}
              </Typography>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Maintenance;
